import React from 'react'
import './LanguageSwitcher.css'
import classNames from 'classnames'

const LanguageSwitcher = ({ languages = [], currentLanguage = 'Fi', visible = false, handleLangSwitcherClick, ...props }) => {
  let classes = classNames({
    'LanguageSwitcher': true,
    'm-fadeIn': visible,
    'm-fadeOut': !visible
  })

  return (
    <div className={classes} {...props}>
      {languages.map((l) => {
        let activeClass = classNames({
          'LanguageSwitcher-Lang': true,
          'm-Active': l.langCode === currentLanguage
        })

        return (
          <span
            key={l.langCode} className={activeClass} onClick={e => handleLangSwitcherClick(e, l.langCode)} {...props}>
            {l.langCode}
          </span>
        )
      })}
    </div>
  )
}

export default LanguageSwitcher



// WEBPACK FOOTER //
// ./src/Components/LanguageSwitcher/LanguageSwitcher.js